// extracted by mini-css-extract-plugin
export default {"report-modal":"styles_report-modal__sSR8A","reportModal":"styles_report-modal__sSR8A"};